import { invokeAmTpDemoAiTask } from './invokeAmTpDemoAiTask';
import { TAmDemoAiContextFor } from './types';

/** Returns the clause-by-clause redline and the change chips above it. */
export async function summarizeAmTpDemoDiff(
  context: TAmDemoAiContextFor<'diff.summarize'>
) {
  return invokeAmTpDemoAiTask('diff.summarize', context);
}
